import classNames from "classnames";

import { CCard, CCardBody } from "@coreui/react";

import { CActionGroup } from "src/common/components/others";
import { useMobileDevice } from "src/utils/hooks/viewport";

export const MarkToolbar = ({ onSubmit }) => {
  const isMobile = useMobileDevice();
  return (
    <CCard className={classNames("toolbar", !isMobile && "sticky")}>
      <CCardBody>
        <div>
          <CActionGroup onClick={onSubmit} canAdd={false} canSave hideEditBtn />
        </div>
      </CCardBody>
    </CCard>
  );
};
